import axios, { AxiosInstance } from "axios";
import toast from "react-hot-toast";
import { useAuthStore } from "../store/authStorage";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const api: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 500000,
  headers: {
    "Content-Type": "application/json",
  },
});

const getAccessToken = () => {
  try {
    const state = useAuthStore.getState();
    return {
      accessToken: state.accessToken || null,
      refreshToken: state.refreshToken || null,
    };
  } catch (error) {
    console.error("Token retrieval error:", error);
    return { accessToken: null, refreshToken: null };
  }
};

api.interceptors.request.use((config) => {
  const { accessToken } = getAccessToken();
  if (accessToken) {
    config.headers.Authorization = accessToken;
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    if (response.data?.expired) {
      useAuthStore.getState().logout();
      window.location.href = "/auth/login";
      toast.error("로그인이 만료되었습니다. 다시 로그인해주세요.");
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      console.log("인증 에러", error.response);
      // 401 에러 시 로그아웃 처리
      useAuthStore.getState().logout();
      window.location.href = "/auth/login";
    }
    return Promise.reject(error);
  }
);
